// src/pages/CourseTime/components/slides/layouts/GraphicAndTextSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import CaseStudyCard from './HtmlContent/CaseStudyCard.comp';
import WhyOutcomeCards from './HtmlContent/WhyOutcomeCards.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';
import { getCaseStudyPart, getCaseStudyTitle } from '../../../utils/caseStudy';

// Layout: TemplateGraphicAndText (big_idea / case_study / why sub-kinds)
const GraphicAndTextSlide = ({ slide, renderSpokenText, skipTitleSpeech, collapsed, pageLc }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  const origin = slide._pbdq_origin || slide;
  const isBigIdea = slide._pbdq_kind === 'big_idea' || origin.slide_type === 'big_idea';
  const isCaseStudy = slide._pbdq_kind === 'case_study' || origin.slide_type === 'case_study';
  // The case study image belongs to part 1; part 2 always takes the full width.
  const isCaseStudyPartTwo = isCaseStudy && getCaseStudyPart(origin) === 2;
  const isWhy = slide._pbdq_kind === 'why' || origin.slide_type === 'why';
  const isIllustrative = origin.is_illustrative;
  const bigIdeaText = origin.big_idea || '';
  const bigIdeaSubtext = origin.subtext || '';

  return (
    <S.SlideWithImage collapsed={collapsed}>
      <S.SlideTitleMobile>
        {isCaseStudy
          ? getCaseStudyTitle(slide, origin)
          : <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        }
      </S.SlideTitleMobile>
      {!isWhy && !isCaseStudyPartTwo && slide.Images && slide.Images.length > 0 && (
        <S.SlideImageContainer>
          <S.SlideImage
            src={typeof slide.Images[0] === 'string' ? slide.Images[0] : slide.Images[0].url || ''}
            alt={`Slide ${slide.SlideOrder} image`}
          />
        </S.SlideImageContainer>
      )}
      <S.SlidePointsContainer>
        <S.SlidePoint>
          <S.SlideTitle className="mobile-hidden">
            {isCaseStudy
              ? getCaseStudyTitle(slide, origin)
              : <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
            }
          </S.SlideTitle>

          {isCaseStudy && isIllustrative && (
            <div className="illustrative-badge" style={{ marginBottom: 12 }}>
              Illustrative example
            </div>
          )}

          {isCaseStudy ? (
            // Section cards and paragraphs are blocks, so they render outside PointText (a <p>).
            <CaseStudyCard slide={slide} origin={origin} pageLc={pageLc} />
          ) : (
            <S.PointText className={isBigIdea ? 'big-idea-text' : ''}>
              {(() => {
                if (isWhy) {
                  return <WhyOutcomeCards slide={slide} origin={origin} />;
                }
                if (isBigIdea && (bigIdeaText || bigIdeaSubtext)) {
                  return (
                    <>
                      {bigIdeaText && renderContent('content_0', bigIdeaText)}
                      {bigIdeaSubtext && <p className="content-body">{renderContent('content_1', bigIdeaSubtext)}</p>}
                    </>
                  );
                }
                return renderContent('content_0', slide.SlideContent);
              })()}
            </S.PointText>
          )}
        </S.SlidePoint>
      </S.SlidePointsContainer>
    </S.SlideWithImage>
  );
};

export default GraphicAndTextSlide;
